import {ColumnMain} from "../column-main";
import {Column} from "../column";
import {Trans} from "@lingui/macro";
import React from "react";

const SupplierOrderModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    columns.push({key:'orderId.orderNumber', dataIndex: ['orderId', 'orderNumber'], fixed: 'left', width: 300, direction:"asc", sorter:true, filter:true, title:<Trans>Order number</Trans>});
    columns.push({key:'orderId.lotNumber', dataIndex: ['orderId', 'lotNumber'], width: 150, sorter:true, filter:true, title:<Trans>Lot</Trans>});

    const productColumns: Array<Column> = new Array();
    productColumns.push({key:'orderId.productCode', dataIndex: ['orderId', 'productCode'], width: 200, sorter:true, filter:true, title:<Trans>Code</Trans>});
    productColumns.push({key:'product.name', dataIndex: ['product', 'name'], sorter:true, width: 360, filter:true, title:<Trans>Name</Trans>});
    productColumns.push({key:'product.type', dataIndex: ['product', 'type'], sorter:true, width: 150, filter:true, title:<Trans>Type</Trans>});
    columns.push({
        key: 'product',
        width: 157,
        sorter: false,
        filter: false,
        title: <Trans>Product</Trans>,
        children: productColumns,
    });

    const qtyColumns: Array<Column> = new Array();

    qtyColumns.push({key:'orderQuantity', sorter:true, width: 150, filter:true, title:<Trans>Ordered</Trans>});
    qtyColumns.push({key:'receivedQuantity', sorter:true, width: 150, filter:true, title:<Trans>Received</Trans>});
    columns.push({
        key: 'qty',
        width: 157,
        sorter: false,
        filter: false,
        title: <Trans>Quantity</Trans>,
        children: qtyColumns,
    });


    columns.push({key:'status', width: 150, tags:[
            {text:'ORDERED',color:'green'},
            {text:'RECEIVED',color:'orange'},
            {text:'RECEIVING_IN_PROGRESS',color:'purple'},
            {text:'DELETED_BY_KULCSSOFT',color:'red'},
        ],
        uniqueSelectFilterData:[
            {
                label:<Trans>NONE</Trans>,
                value:null
            },{
                label:<Trans>RECEIVED</Trans>,
                value:"RECEIVED"
            },{
                label:<Trans>RECEIVING_IN_PROGRESS</Trans>,
                value:"RECEIVING_IN_PROGRESS"
            },{
                label:<Trans>ORDERED</Trans>,
                value:"ORDERED"
            },{
                label:<Trans>DELETED_BY_KULCSSOFT</Trans>,
                value:"DELETED_BY_KULCSSOFT"
            }
        ],
        sorter:true, title:<Trans>Status</Trans>
    });

    columns.push({key:'uploadedToKulcsSoft', width: 160, sorter:true, checkboxFilter: true, title:<Trans>Uploaded To KS</Trans>});
    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 200, dateFilter:true, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Created Date</Trans>});
    columns.push({key:'createdBy', width: 200, dateFilter:true, sorter:true,title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/supplier-orders"
    };

}
export default SupplierOrderModel();
